import { ref } from 'vue';
import { useHttp } from '@/composables';
import { useRouter } from 'vue-router';
import { HttpStatusCode } from 'axios';

export function useFormSubmit() {
  const router = useRouter();
  const isSubmitting = ref(false);
  const error = ref(null);
  const errors = ref(null);

  const submit = async (modelId, formData, successRoute, endpoint) => {
    isSubmitting.value = true;
    errors.value = null;

    const response = await (modelId
      ? useHttp().put(`/${endpoint}/${modelId}`, formData)
      : useHttp().post(`/${endpoint}`, formData));

    if (response.statusCode === HttpStatusCode.Ok) {
      if (successRoute) {
        await router.push({ name: successRoute });
      }
    } else {
      error.value = response.exception;
      errors.value = response.errors;
    }

    isSubmitting.value = false;

    return response;
  };

  const hasValidationError = fieldName => {
    return errors.value && fieldName in errors.value;
  };

  const getValidationError = fieldName => {
    if (hasValidationError(fieldName)) {
      return errors.value[fieldName][0];
    }

    return null;
  };

  return {
    isSubmitting,
    error,
    errors,
    submit,
    hasValidationError,
    getValidationError,
  };
}
